import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import { UserContext } from "../../Providers/UserContext";
import { useNavigate, useLocation } from "react-router-dom";
import {
  BodyItemCount,
  BodyItemIcon,
  BodyItemName,
  BtnTextTitle,
  BtnTextValue,
  CasinoContainer,
  CasinoMain,
  CasinoNavigation,
  CasinoNavigationBody,
  CasinoNavigationBodyItem,
  CasinoNavigationBodyList,
  CasinoNavigationBodyTitle,
  CasinoNavigationSearch,
  CasinoWrapper,
  HotButton,
  HotPopularBtns,
  HotPopularButtonText,
  IframeBody,
  IframeHeader,
  IframeWrapper,
  JackpotPanel,
  JackpotPanelContainer,
  JackpotPanelTitle,
  JackpotSlider,
  PopularButton,
} from "./styled";
import Header from "../../layout/Header";
import { FaSearch } from "react-icons/fa";
import { Heat } from "../../assets/svg/Heat";
import { Popular } from "../../assets/svg/Popular";
import ImageSlider from "../../components/ImageSlider";
import MobileNavFooter from "../../layout/MobileFooter/MobileNavFooter";
import MobileFooter from "../../layout/MobileFooter";
import { category_list } from "../../config/category";
import axios from "axios";
import CategoryList from "./categorylist";
import GameList from "./gamelist";
import { smallScreens, smallWidthScreens } from "../../utils/intervals";
import { useTypedDispatch, useTypedSelector } from "../../store/typeHooks";
import ogsGameList from "../../config/gameList.json";
import newGameList from "../../config/newGame.json";
import { GameResponse, newGame, ogsGame } from "../../API/game";
import { FaExpand, FaCompress } from "react-icons/fa6";

import NetentSvg from "../../assets/svg/categories/netgame.svg";
import AmaticSvg from "../../assets/svg/categories/amatic.svg";
import NovomaticSvg from "../../assets/svg/categories/novomatic.svg";
import QuickspinSvg from "../../assets/svg/categories/quickspin.svg";
import egtSvg from "../../assets/svg/categories/egt.svg";
import PlayngoSvg from "../../assets/svg/categories/playngo.svg";
import PragmaticSvg from "../../assets/svg/categories/pragmatic.svg";
import YggdrasilSvg from "../../assets/svg/categories/yggdrasil.svg";
import ZeplinSvg from "../../assets/svg/categories/zeplin.svg";
import RiverSvg from "../../assets/svg/categories/river.svg";
import SgSvg from "../../assets/svg/categories/sg.svg";
import AristocratSvg from "../../assets/svg/categories/Aristocrat.svg";
import { MdClose } from "react-icons/md";

type Category = { name: string; path: string };

const OGS_PROVIDERS = new Set([
  "NETENT2",
  "AMATIC2",
  "NOVOMATIC2",
  "ARISTOCRAT2",
  "EGT2",
  "PlayNGo",
  "PragmaticPlay",
  "River",
  "Scientific",
  "Yggdrasil",
  "Zeppelin",
]);

const ICON_BY_PROVIDER: Record<string, string> = {
  NETENT: NetentSvg,
  AMATIC: AmaticSvg,
  NOVOMATIC: NovomaticSvg,
  QUICKSPIN: QuickspinSvg,
  EGT: egtSvg,
  NETENT2: NetentSvg,
  AMATIC2: AmaticSvg,
  NOVOMATIC2: NovomaticSvg,
  ARISTOCRAT2: AristocratSvg,
  EGT2: egtSvg,
  PlayNGo: PlayngoSvg,
  PragmaticPlay: PragmaticSvg,
  River: RiverSvg,
  Scientific: SgSvg,
  Yggdrasil: YggdrasilSvg,
  Zeppelin: ZeplinSvg,
};

const Casino: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useTypedDispatch();

  const {
    isMobile,
    netentGame,
    setNetentGame,
    amaticGame,
    setAmaticGame,
    novomaticGame,
    setNovomaticGame,
    quickspinGame,
    setQuickspinGame,
    egtGame,
    setEgtGame,
    egteqGame,
    setEgtEQGame,
    pragmaticGame,
    setPragmaticGame,
    pateGame,
    setPateGame,
    merkurGame,
    setMerkurGame,
    egtdigitalGame,
    setEgtdigitalGame,
    ainsworthGame,
    setAinsworthGame,
    gameSession,
    setGameSession,
    isOrder,
  } = useContext(UserContext);

  const { id, isLogin, email } = useTypedSelector((state) => state.auth);

  const [categories, setCategories] = useState<Category[]>([]);
  const [category, setCategory] = useState<Category>({ name: "", path: "" });
  const [isVisible, setVisible] = useState<boolean>(false);
  const [isOpen, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [gameName, setGameName] = useState("");
  const [isExpand, setIsExpand] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);

  // Build a map of OGS counts once.
  const ogsCountByProvider = useMemo(() => {
    const map = new Map<string, number>();
    (ogsGameList as Array<{ provider: string }>).forEach((g) => {
      map.set(g.provider, (map.get(g.provider) ?? 0) + 1);
    });
    return map;
  }, []);

  // RGS arrays map for counts
  const rgsArrayByProvider = useMemo(
    () => ({
      NETENT: netentGame ?? [],
      EGT_EQ: egteqGame ?? [],
      PRAGMATIC: pragmaticGame ?? [],
      PATE: pateGame ?? [],
      MERKUR: merkurGame ?? [],
      EGT_DIGITAL: egtdigitalGame ?? [],
      AINSWORTH: ainsworthGame ?? [],
      AMATIC: amaticGame ?? [],
      NOVOMATIC: novomaticGame ?? [],
      QUICKSPIN: quickspinGame ?? [],
      EGT: egtGame ?? [],
    }),
    [
      netentGame,
      egteqGame,
      pragmaticGame,
      pateGame,
      merkurGame,
      egtdigitalGame,
      ainsworthGame,
      amaticGame,
      novomaticGame,
      quickspinGame,
      egtGame,
    ]
  );

  const getCount = useCallback(
    (name: string) => {
      if (name === "New Games") return (newGameList as any[]).length;
      if (OGS_PROVIDERS.has(name)) return ogsCountByProvider.get(name) ?? 0;
      return (rgsArrayByProvider as any)[name]?.length ?? 0;
    },
    [ogsCountByProvider, rgsArrayByProvider]
  );

  // Initial load when order is ready
  useEffect(() => {
    if (!isOrder) return;
    setCategories(category_list as Category[]);
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrder]);

  // Route change effects
  useEffect(() => {
    if (location.pathname === "/casino") {
      setVisible(false);
      setCategory({ name: "", path: "" });
    }

    if (location.pathname.includes("casino/play/")) {
      getGameData();
    } else {
      if (gameSession) closeGameSession();
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const launchToMobileOrOpen = (launchUrl: string, displayName: string) => {
    if (smallScreens.matches || smallWidthScreens.matches) {
      navigate("/play/mobile", { state: { url: launchUrl, gameName: displayName } });
    } else {
      setUrl(launchUrl);
      setOpen(true);
    }
  };

  const getGameData = useCallback(async () => {

    console.log(id);

    if (!isLogin) {
      navigate("/", { state: { modal: "login" } });
      return;
    }

    const state = location.state as any;
    if (!state?.gameItem) return;

    let launchUrl = "";

    try {
      if (state.api === "news") {
        let url = '';
        setGameName(state.gameItem.gameName);
        const data = {
          login: email,
          gameUuid: state.gameItem.gameUuid,
          gameCode: state.gameItem.gameCode,
        };

        await dispatch(newGame(data))
          .then((result) => {
            console.log("result: ", result);
            url = (result.payload as GameResponse).url;
          })
          .catch((err: any) => {
            console.log(err);
          });
        if (smallScreens.matches || smallWidthScreens.matches) {
          navigate("/play/mobile", { state: { url, gameName: state.gameItem.displayName } });
        } else {
          console.log("url: ", url);
          setUrl(url);
          setOpen(true);
        }
        return;
      }

      if (state.api === "ogs") {
        setGameName(state.gameItem.displayName);
        const isIdProvider =
          state.provider === "PlayNGo" ||
          state.provider === "NETENT2" ||
          state.provider === "PragmaticPlay" ||
          state.provider === "ARISTOCRAT2";

        const data = {
          username: email,
          sessionId: id,
          game: isIdProvider ? state.gameItem.gameId : state.gameItem.gameName,
          provider: state.provider,
        };

        const result = await dispatch(ogsGame(data)).unwrap();
        launchUrl = (result as GameResponse).url;
        launchToMobileOrOpen(launchUrl, state.gameItem.displayName);
        return;
      }

      // RGS (internal)
      setGameName(state.gameItem.name);
      const operator_id = "apiapi";
      const lobby_url = "https://youslots.netlify.app/close.html";
      const game_uuid = state.gameItem.uuid;
      const device = isMobile ? "MOBILE" : "DESKTOP";
      launchUrl = `https://ss.game-services.work/platform/api/game/launch?operator_id=${operator_id}&player_token=${id}&game_uuid=${game_uuid}&lobby_url=${lobby_url}&currency=USD&device_type=${device}`;
      launchToMobileOrOpen(launchUrl, state.gameItem.name);
    } catch (err) {
      console.log("Failed to get game data", err);
    }
  }, [dispatch, email, id, isLogin, isMobile, location.state, navigate]);

  const closeGameSession = async () => {
    try {
      const user_id = id;
      const hash = "hash_" + Date.now();
      await axios.get(
        `https://apissl.b-cdn.net/api/withdraw_balance?token=testagent21&secret_key=argentina&user_id=${user_id}&group_id=40994&hash=${hash}`
      );
      await axios.get(
        `https://apissl.b-cdn.net/api/close_session?token=testagent21&secret_key=argentina&user_id=${user_id}&group_id=40994`
      );
      setGameSession("");
    } catch (err) {
      console.log("Close session error", err);
    }
  };

  const RGS_SETTERS: Record<string, (games: any[]) => void> = {
    NETENT: setNetentGame,
    EGT_EQ: setEgtEQGame,
    PRAGMATIC: setPragmaticGame,
    PATE: setPateGame,
    MERKUR: setMerkurGame,
    EGT_DIGITAL: setEgtdigitalGame,
    AINSWORTH: setAinsworthGame,
    AMATIC: setAmaticGame,
    NOVOMATIC: setNovomaticGame,
    QUICKSPIN: setQuickspinGame,
    EGT: setEgtGame,
  };

  const getData = async () => {
    setLoadingCategories(true);
    try {
      const requests = (category_list as Category[])
        .filter((c) => c.name !== "New Games" && !OGS_PROVIDERS.has(c.name))
        .map((c) =>
          axios
            .get(`https://ss.game-services.work/platform/api/games?softwareProvider=${c.name}`)
            .then((res) => RGS_SETTERS[c.name]?.(res.data))
            .catch((err) => console.log("Fetch error:", c.name, err))
        );

      await Promise.allSettled(requests);
    } finally {
      setLoadingCategories(false);
    }
  };

  const handleCategory = (item: any) => {
    setCategory(item);
    setVisible(true);
    setOpen(false);
    navigate(`/casino/${item.path}`);
  };

  return (
    <React.Fragment>
      <CasinoWrapper>
        <Header />
        <CasinoContainer>
          <CasinoNavigation>
            <CasinoNavigationSearch>
              <FaSearch color="#7388b6" />
              <input placeholder="Search..." />
            </CasinoNavigationSearch>

            <CasinoNavigationBody>
              <CasinoNavigationBodyTitle>Categories</CasinoNavigationBodyTitle>

              <HotPopularBtns>
                <HotButton>
                  <Heat />
                  <HotPopularButtonText>
                    <BtnTextTitle>Heated</BtnTextTitle>
                    <BtnTextValue>20</BtnTextValue>
                  </HotPopularButtonText>
                </HotButton>
                <PopularButton>
                  <Popular />
                  <HotPopularButtonText>
                    <BtnTextTitle>Popular</BtnTextTitle>
                    <BtnTextValue>218</BtnTextValue>
                  </HotPopularButtonText>
                </PopularButton>
              </HotPopularBtns>

              <CasinoNavigationBodyList>
                {categories.map((item) => {
                  const icon = ICON_BY_PROVIDER[item.name];
                  return (
                    <CasinoNavigationBodyItem
                      key={item.path}
                      onClick={() => handleCategory(item)}
                      flag={item.name === category.name}
                    >
                      <BodyItemIcon>
                        {icon ? <img src={icon} alt={item.name} width={25} height={25} /> : null}
                      </BodyItemIcon>
                      <BodyItemName>{item.name}</BodyItemName>
                      <BodyItemCount>{getCount(item.name)}</BodyItemCount>
                    </CasinoNavigationBodyItem>
                  );
                })}
              </CasinoNavigationBodyList>
            </CasinoNavigationBody>
          </CasinoNavigation>

          {isOpen ? (
            <IframeWrapper
              style={isExpand ? { position: "fixed", top: 0, left: 0, zIndex: 9999, height: "100vh" } : { position: "relative" }}
            >
              <IframeHeader>
                <p>{gameName}</p>
                <MdClose size={30} style={{ cursor: "pointer" }} onClick={() => navigate("/casino")} />
              </IframeHeader>
              <IframeBody>
                <div
                  style={{
                    position: "absolute",
                    margin: "30px",
                    backgroundColor: "#2b3843",
                    padding: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => setIsExpand(!isExpand)}
                >
                  {!isExpand ? <FaExpand /> : <FaCompress />}
                </div>
                <iframe
                  style={{ width: "100%", height: "100%" }}
                  scrolling="no"
                  frameBorder="no"
                  title="gameIfram"
                  id="gameIFrame"
                  src={url}
                />
              </IframeBody>
            </IframeWrapper>
          ) : (
            <CasinoMain>
              <JackpotPanelContainer>
                <JackpotPanel>
                  <JackpotPanelTitle>
                    <span>Jackpot</span>
                  </JackpotPanelTitle>
                </JackpotPanel>
                <JackpotSlider>
                  <ImageSlider />
                </JackpotSlider>
              </JackpotPanelContainer>

              {isVisible ? (
                <GameList category={category} />
              ) : (
                <CategoryList
                  categories={categories}
                  category={category}
                  setCategory={handleCategory}
                  isLoading={loadingCategories}
                />
              )}
            </CasinoMain>
          )}
        </CasinoContainer>

        <MobileFooter />
        <MobileNavFooter />
      </CasinoWrapper>
    </React.Fragment>
  );
};

export default Casino;
